import React from 'react';
import './style.css';
import BannerImg from '../ArticleList/img/articlelist.png';

function ArticleDetailBanner({ title = 'Article Title', author = 'Inside Injuries Team', publishDate = 'November 1, 2025', thumbnail }) {
  // Format the date if needed
  const formattedDate = new Date(publishDate).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  // Use thumbnail from API if available, otherwise use default banner image
  const backgroundImage = thumbnail || BannerImg;

  return (
    <div className='al-banner' style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className='al-banner__overlay' />
      <div className='al-banner__content'>
        <h1 className='al-banner__title'>{title}</h1>
        <h3 className='al-banner__eyebrow'>By {author}</h3>
        <p className='al-banner__subtitle'>{formattedDate}</p>
      </div>
    </div>
  );
}

export default ArticleDetailBanner;
